<template>
    <div class="nva-box">
        <div class="box">
            <el-menu router :default-active="activeMenuName" class="el-menu-demo hidden-sm-and-down" mode="horizontal"
                @select="handleSelect" text-color="#495060" active-text-color="#2196f3">
                <div class="logo">
                    <el-image fit="scale-down" @click="goHome" style="width: 80px; height: 50px"
                        src="https://file.magaoedu.com/c605c1d8cb4b2315c258fdee2bce551f.jpg"></el-image>
                </div>
                <el-menu-item index="/"><i class="el-icon-s-home navbar-icon"></i>首页</el-menu-item>
                <el-submenu index="4" style="text-align: center">
                    <template slot="title"> <i class="el-icon-menu navbar-icon"></i>代码编辑器 </template>
                    <el-menu-item index="2">C++</el-menu-item>
                    <el-menu-item @click="goPython">Python</el-menu-item>
                    <el-menu-item @click="goScratch">Scratch</el-menu-item>
                    <el-menu-item v-if="isShowScratch3d" @click="goPyhton3D">Python3D</el-menu-item>
                    <el-menu-item v-if="isShowScratch3d" @click="goScratch3D">Scratch3D</el-menu-item>
                </el-submenu>
                <el-menu-item index="1"><i class="el-icon-s-grid navbar-icon"></i>题库练习</el-menu-item>
                <el-submenu index="8" style="text-align: center">
                    <template slot="title"><i class="el-icon-document navbar-icon"></i> 阶段测评 </template>
                    <el-menu-item index="/evaluation?type=3">C++</el-menu-item>
                    <el-menu-item index="/evaluation?type=2">Python</el-menu-item>
                    <el-menu-item index="/evaluation?type=1">Scratch</el-menu-item>
                </el-submenu>
                <!-- <el-menu-item index="/gameCenter"><i class="el-icon-chat-dot-round navbar-icon"></i>交流中心</el-menu-item> -->
                <el-menu-item title="打字练习提升速度、准确性，培养专注力，助力未来" @click="gotodo"><img style="margin:-6px 7px 0px 0px;"
                        src="./download/key.svg">打字练习</el-menu-item>
                <el-submenu index="5" style="text-align: center">
                    <template slot="title"> 更多内容 </template>
                    <el-menu-item index="/download">下载中心</el-menu-item>
                    <el-menu-item @click="goTest">图形化测评</el-menu-item>
                </el-submenu>
                <el-submenu index="3" style="float: right; margin-right: 30px; text-align: center">
                    <template slot="title">
                        <el-avatar :size="30" style="margin-right: 5px" class="view_avatar"
                            :src="loginInfo && loginInfo.studentImg ? loginInfo.studentImg : 'https://file.magaoedu.com/83550584c13f84e96c95f93b79ac8ce3.jpg'"></el-avatar>
                        <span style="font-weight: bold; color: #409eff; font-size: 18px">{{ loginInfo.userName }}</span>
                    </template>
                    <el-menu-item index="/personSetting" class="menu-item-nva">
                        <img src="./download/setting.svg">
                        个人设置
                    </el-menu-item>
                    <el-menu-item index="/personalWorks" class="menu-item-nva">
                        <img src="./download/work.svg">
                        我的作品
                    </el-menu-item>
                    <el-menu-item index="/rechargeRecords" class="menu-item-nva">
                        <img src="./download/records.svg">
                        充值记录
                    </el-menu-item>
                    <el-menu-item class="menu-item-nva" v-if="isShow" @click="goHref">
                        云校后台
                    </el-menu-item>
                    <el-menu-item class="menu-item-nva" @click="logout">
                        <img src="./download/logout.svg">
                        退出登录
                    </el-menu-item>
                </el-submenu>
            </el-menu>
            <div @click="drawer = true" style="float: right; cursor: pointer; margin: 5px 5px" class="hidden-md-and-up">
                <el-avatar :size="50" class="view_avatar"
                    :src="loginInfo && loginInfo.studentImg ? loginInfo.studentImg : 'https://file.magaoedu.com/8981fbc4f2fd4b3aab4d93e61c6aabc3.png'"></el-avatar>
            </div>
            <el-drawer title="" :modal="false" :with-header="false" :visible.sync="drawer" direction="rtl"
                :show-close="false">
                <el-menu default-active="/" router class="el-menu-vertical-demo">
                    <el-menu-item index="/"><i class="el-icon-s-home navbar-icon"></i>首页</el-menu-item>
                    <el-submenu index="4">
                        <template slot="title"> <i class="el-icon-menu navbar-icon"></i>代码编辑器 </template>
                        <el-menu-item index="2">C++</el-menu-item>
                        <el-menu-item @click="goPython">Python</el-menu-item>
                        <el-menu-item @click="goScratch">Scratch</el-menu-item>
                    </el-submenu>
                    <el-menu-item index="1"><i class="el-icon-s-grid navbar-icon"></i>题库练习</el-menu-item>
                    <el-menu-item index="/evaluation?type=3"><i
                            class="el-icon-document navbar-icon"></i>阶段测评</el-menu-item>
                    <el-submenu index="3">
                        <template slot="title">
                            <span>{{ loginInfo.userName }}</span>
                        </template>
                        <el-menu-item index="/personSetting" class="menu-item-nva">
                            <img src="./download/setting.svg">
                            个人设置
                        </el-menu-item>
                        <el-menu-item index="/personalWorks" class="menu-item-nva">
                            <img src="./download/work.svg">
                            我的作品
                        </el-menu-item>
                        <el-menu-item class="menu-item-nva" v-if="isShow" @click="goHref">
                            云校后台
                        </el-menu-item>
                        <el-menu-item class="menu-item-nva" @click="logout">
                            <img src="./download/logout.svg">
                            退出登录
                        </el-menu-item>
                    </el-submenu>
                </el-menu>
            </el-drawer>
        </div>
    </div>
</template>
<script>
import "element-ui/lib/theme-chalk/display.css";
export default {
    name: "nvaBar",
    data() {
        return {
            drawer: false,
            activeIndex2: "/",
            loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
            isShow: false,

            phoneArr: [
                18600097157,
                13163695556,
                18649090070,
                13832036022,
                17615229198,
                18612108941,
                13146025991,
                18515098678,
                13120001647,
                15735640797,
                18340861677,

            ]
        };
    },
    computed: {
        activeMenuName() {
            return "/";
        },
        isShowScratch3d() {
            return this.$store.state.isShowScratch3d
        }
    },
    mounted() {
        this.getUserinfo();
        this.$bus.$on("listeningToPassword", (_) => {
            this.getUserinfo();
        });
        this.$nextTick(function () {
            // 按下键盘
            document.addEventListener("keydown", (e) => {
                if (e.keyCode === 8 && e.shiftKey) {
                    this.isShow = true;
                }
                if (e.keyCode === 13 && e.altKey) {
                    this.isShow = true;
                }
            });
        });
    },
    methods: {
        goDown() {
            window.open('');
        },
        goTest() {
            window.open('https://game.magaoedu.com/zh-hans/index.html');
        },
        gotodo() {
            window.open('http://typing.magaoedu.com/');
        },
        goPython() {
            let obj = JSON.parse(localStorage.getItem('userinfo'));
            sessionStorage.fileUrl = '';
            sessionStorage.videoUrl = '';
            sessionStorage.id = '';
            sessionStorage.isCrm = this.loginInfo.isCrm;
            let img = obj.studentImg ? obj.studentImg : 'https://file.magaoedu.com/8981fbc4f2fd4b3aab4d93e61c6aabc3.png'
            this.$todo.setLocal('user_image', img);
            window.open('/static/pythonS/pythonIDE.html');
        },
        goScratch() {
            sessionStorage.isJob = "0"; //标识自由创作
            sessionStorage.fileUrl = ""; //文件
            sessionStorage.id = ""; //非编辑
            sessionStorage.belongVideoId = ""; //视频id
            sessionStorage.loginType = "";
            sessionStorage.videoName = "";
            sessionStorage.levelName = "";
            sessionStorage.levelId = "";
            sessionStorage.objId = "";
            sessionStorage.videoId = "";
            sessionStorage.objName = "";
            sessionStorage.isCrm = this.loginInfo.isCrm;
            window.open('/static/build/index.html')
        },
        goScratch3D() {
            sessionStorage.removeItem('videoUrl')
            sessionStorage.fileurl = '';
            localStorage.block = '';
            localStorage.seed = '';
            localStorage.position = '';
            let obj = JSON.parse(localStorage.getItem('userinfo'));
            window.open(`/static/scratch3D/index.html?studentId=${obj.id}&isShow=${obj.isShow}`);
        },
        goScratch3Dv2() {
            sessionStorage.removeItem('videoUrl')
            sessionStorage.fileurl = '';
            localStorage.block = '';
            localStorage.seed = '';
            localStorage.position = '';
            let obj = JSON.parse(localStorage.getItem('userinfo'));
            window.open(`/static/scratch3Dv2/index.html?studentId=${obj.id}&isShow=${obj.isShow}`);
        },
        goPyhton3D() {
            sessionStorage.removeItem('videoUrl')
            sessionStorage.fileurl = '';
            localStorage.block = '';
            localStorage.seed = '';
            localStorage.position = '';
            let obj = JSON.parse(localStorage.getItem('userinfo'));
            window.open(`/static/python_3d/ace.html?studentId=${obj.id}&isShow=${obj.isShow}`);
        },
        goHref() {
            window.open('https://school.magaoedu.com/')
        },
        async getUserinfo() {
            let api = '';
            this.loginInfo.isCrm == '1' ? api = this.$API.studentInfo : api = this.$API.studentInfoC;
            let result = await this.$axios.post(api, this.$todo.formData({
                token: this.$store.state.token,
            }));
            this.loginInfo = { ...this.loginInfo, ...result.data };
            this.$store.commit('SETUSERNAME', this.loginInfo.studentCode);
            this.$store.commit('PASSWORD', this.loginInfo.studentPassword);
            this.$todo.setLocal('userinfo', this.loginInfo);
        },
        goHome() {
            this.$router.push('/');
            this.activeIndex2 = '/';
        },
        logout() {
            this.$todo.removeCookie('token');
            this.$store.commit('updateToken', false);
        },
        handleSelect(key, keyPath) {
            if (key == 1) {
                // window.location.href = `http://localhost:8066/problem?${this.loginInfo.studentCode},${this.loginInfo.studentPassword}`
                if (this.loginInfo.studentCode && this.loginInfo.studentPassword) {
                    window.location.href = `https://ojwendao.magaoedu.com/problem?${this.loginInfo.studentCode},${this.loginInfo.studentPassword}`
                } else {
                    this.$message.warning('该账号暂未开通OJ，请联系管理员')
                }

            } else if (key == 2) {
                sessionStorage.fileUrl = '';
                sessionStorage.isCrm = this.loginInfo.isCrm;
                sessionStorage.videoUrl = '';
                sessionStorage.id = ""
                window.open('/static/c++/index.html');
            }
        },
        // goPython() {
        //     let obj = JSON.parse(localStorage.getItem("userinfo"));
        //     sessionStorage.fileUrl = "";
        //     sessionStorage.isCrm = this.loginInfo.isCrm;
        //     let img = obj.studentImg ? obj.studentImg : "https://file.magaoedu.com/8981fbc4f2fd4b3aab4d93e61c6aabc3.png";
        //     this.$todo.setLocal("user_image", img);
        //     window.open("/static/pythonS/pythonIDE.html");
        // },
        goScratch() {
            sessionStorage.isJob = "0"; //标识自由创作
            sessionStorage.fileUrl = ""; //文件
            sessionStorage.id = ""; //非编辑
            sessionStorage.belongVideoId = ""; //视频id
            sessionStorage.loginType = "";
            sessionStorage.videoName = "";
            sessionStorage.levelName = "";
            sessionStorage.levelId = "";
            sessionStorage.objId = "";
            sessionStorage.videoId = "";
            sessionStorage.objName = "";
            sessionStorage.downType = "";
            sessionStorage.isCrm = this.loginInfo.isCrm;
            window.open("/static/build/index.html");
            // window.open('/static/scratch/index.html')
        },
        goHref() {
            window.open("https://school.magaoedu.com/");
        },
        async getUserinfo() {
            let api = "";
            this.loginInfo.isCrm == "1" ? (api = this.$API.studentInfo) : (api = this.$API.studentInfoC);
            let result = await this.$axios.post(
                api,
                this.$todo.formData({
                    token: this.$store.state.token,
                })
            );
            this.loginInfo = { ...this.loginInfo, ...result.data };
            this.$store.commit("SETUSERNAME", this.loginInfo.studentCode);
            this.$store.commit("PASSWORD", this.loginInfo.studentPassword);
            this.$todo.setLocal("userinfo", this.loginInfo);
            let resultPhone = this.phoneArr.some(v => v === Number(this.loginInfo.studentCode));
            this.$store.commit('SETSCRATCH3D', resultPhone)
        },
        goHome() {
            this.$router.push("/");
            this.activeIndex2 = "/";
        },
        logout() {
            this.$todo.removeCookie("token");
            this.$store.commit("updateToken", false);
        },
    },
}

</script>
<style>
.el-menu.el-menu--horizontal {
    border: none !important;
}

.el-menu--popup {
    min-width: 160px !important;
    text-align: center;
}

/* hoj css */
.el-submenu__title i {
    color: #313846 !important;
}

.el-menu-item {
    padding: 0 13px !important;
}

.el-menu-item:hover,
.el-menu .el-menu-item:hover {
    border-bottom: 2px solid #2474b5 !important;
}

.el-menu .el-menu-item:hover,
.el-menu .el-menu-item:hover i,
.el-submenu .el-submenu__title:hover,
.el-submenu .el-submenu__title:hover i {
    outline: 0 !important;
    color: #2e95fb !important;
    background: linear-gradient(270deg, #f2f7fc 0%, #fefefe 100%) !important;
    transition: all 0.2s ease;
}

.el-menu .el-menu-item.is-active,
.el-menu .el-menu-item.is-active i,
.el-submenu.is-active,
.el-submenu.is-active i {
    color: #2e95fb !important;
    background: linear-gradient(270deg, #f2f7fc 0%, #fefefe 100%) !important;
    transition: all 0.2s ease;
}

.el-menu--horizontal .el-menu .el-menu-item:hover,
.el-submenu /deep/.el-submenu__title:hover {
    color: #2e95fb !important;
    background: linear-gradient(270deg, #f2f7fc 0%, #fefefe 100%) !important;
}

.el-menu-item i {
    color: #495060 !important;
}

.is-active .el-submenu__title i,
.is-active {
    color: #2196f3 !important;
}

.el-menu-item.is-active i {
    color: #2196f3 !important;
}

.navbar-icon {
    margin-right: 5px !important;
    width: 24px !important;
    text-align: center !important;
    /* color:#495060; */
}
</style>
<style scoped>
.nva-box {
    width: 100%;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);
}

.logo {
    cursor: pointer;
    margin-left: 2%;
    margin-right: 2%;
    float: left;
    height: 42px;
    margin-top: 5px;
}
</style>
